import type { ColumnTemplate } from 'cdh-data-portal-theme'

export const COLUMNS: ColumnTemplate[] = [
  { header: 'User (email)', minWidth: 240, sortKey: 'email' },
  { header: 'Hub', minWidth: 160, sortKey: 'hub' },
  { header: 'Business object', minWidth: 200, sortKey: 'businessObject' },
  { header: 'Actions', minWidth: 64, align: 'right' },
]

export const localText = {
  emptyStateMessage: 'No data governors match the current filters.',
  removeGovernorTooltip: 'Remove governor',
} as const

export function removeGovernorAriaLabel(email: string): string {
  return `Remove ${email}`
}
